import { createContext, useContext, useState } from "react";

const AuthModalContext = createContext();

export const AuthModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openAuthModal = () => setIsOpen(true);
  const closeAuthModal = () => setIsOpen(false);
  const toggleAuthModal = () => setIsOpen((prev) => !prev);

  return (
    <AuthModalContext.Provider
      value={{ isOpen, openAuthModal, closeAuthModal, toggleAuthModal }}
    >
      {children}
    </AuthModalContext.Provider>
  );
};

export const useAuthModal = () => useContext(AuthModalContext);
